import { Module } from 'vuex';

export const solicitudStore: Module<any, any> = {
  state: {
    solicitud: null,
    modalidad: null,
    convocatoria: null,
  },
  getters: {
    solicitud: state => state.solicitud,
    modalidad: state => state.modalidad,
    convocatoria: state => state.convocatoria,
    proceso: state => state.proceso,
  },
  mutations: {
    setSolicitud(state, identity) {
      state.solicitud = identity;
    },
    setModalidad(state, identity) {
      state.modalidad = identity;
    },
    setProceso(state, identity) {
      state.proceso = identity;
    },
    setConvocatoria(state, identity) {
      state.convocatoria = identity;
    },
    logout(state) {
      state.solicitud = null;
      state.modalidad = null;
      state.convocatoria = null;
    },
  },
};
